import { createContext, useEffect, useState } from "react";
import { collection, getDocs, getDoc, doc, setDoc, addDoc, deleteDoc, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebaseConfig";

export const LabContext = createContext();

export const LabProvider = ({ children }) => {

    const [labs, setLabs] = useState(null);
    const labsRef = collection(db, 'labs');

    useEffect(() => {
        const unSubscribe = onSnapshot(
            query(labsRef, orderBy('createdAt', 'desc')),
            
             (docs) => {
            let list = [];
            docs.forEach(doc => {
                list.push({ ...doc.data(), id: doc.id });
            })
            setLabs(list);
        });

        return () => unSubscribe();
    }, [])


    const getLabById = async (id) => {
        const labRef = doc(db, `labs/${id}`);
        const labSnap = await getDoc(labRef);
        if (labSnap.exists) {
            const lab = {
                ...labSnap.data(),
                id: labSnap.id
            }
            return lab;
        } else {
            return false;
        }

    }

    const saveLab = async (lab) => {
        if (lab.id) {
            let labRef = doc(db, `labs/${lab.id}`);
            return setDoc(labRef, lab);


        } else {
            let labRef = collection(db, `labs`);
            return addDoc(labRef, {...lab, createdAt: new Date()});
        }

    }

    const deleteLab = async (id) => {
        const labRef = doc(db, `labs/${id}`);
        return deleteDoc(labRef);
    }

    return (
        <LabContext.Provider value={{ labs, getLabById, saveLab, deleteLab }}>
            {children}
        </LabContext.Provider>

    )
}




